export enum DynamicFieldConditionOperator {
AND,
OR,
}
